/**
 * Styled Components - Created by cazarez on 07/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  margin: 0 auto;
  border-top: var(--border-regular) solid var(--neutral-secondary);
  padding-top: var(--spacing-24);
  margin-top: var(--spacing-24);
  max-width: 1600px;
  font: 400 12px/20px var(--font-inter);
  color: var(--neutral-secondary);
  @media (max-width: 768px) {
    border-top: unset;
    margin-top: 0;
    padding-top: 0;
    color: var(--neutral-muted);
  }
`

export const Text = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: var(--spacing-24);
  a {
    font: 400 12px/20px var(--font-inter);
    color: var(--neutral-secondary);
    margin-left: var(--spacing-24);
    &:hover {
      color: var(--neutral-white);
    }
  }
  #divider {
    display: none;
    margin-inline: var(--spacing-16);
  }
  @media (max-width: 768px) {
    flex-flow: column;
    align-items: center;
    #divider {
      display: inline-block;
    }
    a {
      color: var(--neutral-muted);
      margin-left: unset;
    }
    .terms {
      margin-top: var(--spacing-12);
    }
  }
`

export const SocialLogosContainer = styled.div`
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`

export const StyledImg = styled.img`
  margin-right: var(--spacing-24);
  max-width: 20px;
  width: 100%;
  transition: filter .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.5);
  }

  @media (max-width: 768px) {
    margin: 0 var(--spacing-12);
    max-width: var(--spacing-24);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SocialMedia/styledComponents.tsx